/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { EventBusModule } from "@vlinder-web/event-bus-module-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { BaseApplication } from "./base/baseApplication";
import { UnitTest } from "./unit.test";
import {
  AppNavigatorService,
  LandingPageService,
  PrivacyPageService,
  TermsPageService,
  ProductDetailPageService,
  HolderEPortfolioCertTemplatesPageService,
  ApprovedEPortfolioCertificatesPageService,
  EportfolioProductDetailPageService
} from "../services";

import { DEFAULT_APP_CONFIG } from "../config/default.config";

const parse = require("url-parse");

export class VApplication extends BaseApplication {
  private static instance: VApplication;

  private constructor(options: any = {}) {
    super(options);

    this.setupBindings();

    //Modules
    this.initModules();

    //Services
    this.initServices();
  }

  static getInstance(options: any = {}) {
    if (!this.instance) {
      this.instance = new VApplication(options);
    }
    return this.instance;
  }

  // @ts-ignore
  async start() {
    await this.initRunLevel();
    await this.unitTest();
  }

  setupBindings() {
    //------------->>>>>--------------//
    //------------->>>>>--------------//
  }

  async initRunLevel() {
    //------------->>>>>--------------//
    // const storageSrv = StorageModule.getInstance();
    // const DEFAULT_APP_CONFIG = storageSrv.get("appConfig", "session");
    //------------->>>>>--------------//
    const graphqlModule = this.getSync(
      "services.GraphqlServerModule"
    ) as GraphqlServerModule;
    if (graphqlModule) {
      type TClient = typeof DEFAULT_APP_CONFIG.servers.graphql[0];
      DEFAULT_APP_CONFIG?.servers.graphql.forEach(async (client: TClient) => {
        await graphqlModule
          .createClient(client.name, {
            url: client.url,
            getContext: this.getGraphQLContext.bind(this),
          })
          .then((res) => {
            console.log(`initRunLevel check`, res);
          })
          .catch((err) => {
            console.warn(`error in initRunLevel  ${err.message}`);
          });
      });
    }
    //------------->>>>>--------------//
  }

  async unitTest() {
    const ut = new UnitTest(VApplication);
    ut.run();
  }

  initModules() {
    this.service("services.EventBusModule", EventBusModule);
    this.service("services.GraphqlServerModule", GraphqlServerModule);
  }

  initServices() {
    this.service("services.AppNavigatorService", AppNavigatorService);
    this.service("services.LandingPageService", LandingPageService);
    this.service("services.PrivacyPageService", PrivacyPageService);
    this.service("services.TermsPageService", TermsPageService);
    this.service("services.ProductDetailPageService", ProductDetailPageService);
    this.service("services.HolderEPortfolioCertTemplatesPageService", HolderEPortfolioCertTemplatesPageService);
    this.service("services.ApprovedEPortfolioCertificatesPageService", ApprovedEPortfolioCertificatesPageService);
    this.service("services.EportfolioProductDetailPageService", EportfolioProductDetailPageService);
    

  }

  private getGraphQLContext() {
    const loginService = this.getSync(
      "services.AppNavigatorService"
    ) as AppNavigatorService;
    const url = parse(window.location.href, true);
    let credId;
    let orgId;
    if (url?.query?.tag) {
      credId = url.query.tag;
    }
    if (url?.query?.no) {
      orgId = url.query.no;
    }
    let token = loginService?.getToken();
    // let token = "eyJhbGciOiJSUzUxMiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImFkbWluQGluZHVzLmlvIiwiaWQiOiI2MzMyY2I5MzNhNTdjOWViYTFjNGQxZWIiLCJyb2xlIjoibWFzdGVyIGFkbWluIiwib3JnSWQiOiI2MzMyY2I5MDNhNTdjOWViYTFjNGQxZTgiLCJpYXQiOjE2ODEyODExODIsImV4cCI6MTY4MTM2NzU4MiwiYXVkIjoiZGV2LWRpZ2ljZXJ0LmtsZWZraS5pbyIsImlzcyI6InZsaW5kZXIiLCJzdWIiOiJhZG1pbkBpbmR1cy5pbyIsImp0aSI6IjdmMmUwNzEwLTYzMjktNDVmNi04ZGZmLTgwYTBjMDhjNmQ5NSJ9.D7ybXlQpJb2FsEwqZl8XqAiRZl2QFQA2-Bvq1lPsJOe1M6exg_RP42HNfJZutQAakz4EVde6zAsD0rTm0-ilrQyWdEmHjwZL7Q01ncknTHUIPSXHLpsC40KRkBRa60ijZnkvdvfI5CN2LJJyuLrsYdl0BFCE3P8CdCULDS6XoXQ"
    //FIXME:

    if (token) {
      return {
        headers: {
          authentication: token,
          "org-id": orgId,
          headers: {
            // ...{ ...deviceInfoService?.getDeviceInfo() },
            // ...{ ...deviceInfoService?.getAppInfo() },
          },
        },
      };
    } else {
      return {
        headers: {
          "org-id": orgId,
          headers: {
            // ...{ ...deviceInfoService?.getDeviceInfo() },
            // ...{ ...deviceInfoService?.getAppInfo() },
          },
        },
      };
    }
  }
}
